module.exports = __webpack_public_path__ + "img/logout.2341e14b.svg";